/* Senior Dog Harness — gallery, Colour/Size variant picker, price sync, add to cart. */
(function () {
  'use strict';

  function init(root) {
    if (root.getAttribute('data-sdh-init') === '1') return;
    root.setAttribute('data-sdh-init', '1');

    var dataEl = root.querySelector('[data-sdh-data]');
    if (!dataEl) return;

    var CFG;
    try { CFG = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!CFG || !CFG.variants || !CFG.variants.length) return;

    var form     = root.querySelector('form');
    var varInput = root.querySelector('[data-sdh-variant-input]');
    var atc      = root.querySelector('[data-sdh-atc]');
    var atcLabel = root.querySelector('[data-sdh-atc-label]');
    var priceEl  = root.querySelector('[data-sdh-price-now]');
    var btns     = Array.prototype.slice.call(root.querySelectorAll('[data-sdh-val]'));

    /* ---------------- gallery ---------------- */
    var track  = root.querySelector('[data-sdh-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sdh-thumb]'));

    function markThumbs(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', String(n === i)); });
    }
    function goTo(i, smooth) {
      if (!track) return;
      var slide = track.children[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      markThumbs(i);
    }
    function currentSlide() {
      if (!track || !track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-sdh-thumb'), 10) || 0); });
    });
    var prev = root.querySelector('[data-sdh-prev]');
    var next = root.querySelector('[data-sdh-next]');
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, currentSlide() - 1)); });
    if (next) next.addEventListener('click', function () {
      goTo(Math.min((track ? track.children.length : 1) - 1, currentSlide() + 1));
    });
    if (track) {
      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () { markThumbs(currentSlide()); }, 90);
      }, { passive: true });
    }

    /* ---------------- variant resolution ---------------- */
    var N   = CFG.optCount;
    var sel = (CFG.sel || []).slice();

    function matchesUpTo(v, upto) {
      for (var i = 0; i < upto; i++) { if (v.opts[i] !== sel[i]) return false; }
      return true;
    }
    function isSelectable(oi, val) {
      return CFG.variants.some(function (v) {
        return matchesUpTo(v, oi) && v.opts[oi] === val && v.avail;
      });
    }
    function currentVariant() {
      return CFG.variants.filter(function (v) {
        for (var i = 0; i < N; i++) { if (v.opts[i] !== sel[i]) return false; }
        return true;
      })[0] || null;
    }
    /* After a change at index `from`, nudge later options onto something buyable. */
    function repairFrom(from) {
      for (var oi = from; oi < N; oi++) {
        if (isSelectable(oi, sel[oi])) continue;
        for (var k = 0; k < CFG.variants.length; k++) {
          var v = CFG.variants[k];
          if (matchesUpTo(v, oi) && v.avail) { sel[oi] = v.opts[oi]; break; }
        }
      }
    }

    function update(movedGallery) {
      btns.forEach(function (b) {
        var oi  = parseInt(b.getAttribute('data-sdh-opt'), 10);
        var val = b.getAttribute('data-sdh-val');
        b.setAttribute('aria-checked', String(sel[oi] === val));
        var ok = isSelectable(oi, val);
        b.setAttribute('aria-disabled', String(!ok));
        b.setAttribute('tabindex', sel[oi] === val ? '0' : '-1');
      });

      Array.prototype.slice.call(root.querySelectorAll('[data-sdh-chosen]')).forEach(function (el) {
        var oi = parseInt(el.getAttribute('data-sdh-chosen'), 10);
        el.textContent = sel[oi] || '';
      });

      var v = currentVariant();
      var buyable = !!(v && v.avail);

      if (varInput && v) varInput.value = v.id;
      if (priceEl && v) priceEl.textContent = v.price;

      if (atc) {
        atc.disabled = !buyable;
        if (atcLabel) atcLabel.textContent = buyable ? CFG.cta : CFG.sold;
      }

      if (v && typeof v.imgIdx === 'number' && v.imgIdx >= 0 && movedGallery !== false) {
        goTo(v.imgIdx);
      }

      if (v && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u);
        } catch (e) {}
      }
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        var oi = parseInt(b.getAttribute('data-sdh-opt'), 10);
        sel[oi] = b.getAttribute('data-sdh-val');
        repairFrom(oi + 1);
        update();
      });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        e.preventDefault();
        var group = Array.prototype.slice.call(b.parentNode.querySelectorAll('[data-sdh-val]'));
        var i = group.indexOf(b);
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        var n = group[(i + d + group.length) % group.length];
        if (n) { n.click(); n.focus(); }
      });
    });

    repairFrom(0);
    update(false);

    /* ---------------- add to cart ---------------- */
    function cartRoot() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (atc) atc.classList.add('is-loading');
        fetch(cartRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            if (atc) atc.classList.remove('is-loading');
            if (window.essentialCartApi && typeof essentialCartApi.openCart === 'function') {
              if (typeof essentialCartApi.refreshCart === 'function') essentialCartApi.refreshCart();
              essentialCartApi.openCart();
              return;
            }
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              drawer.open();
              return;
            }
            window.location.href = cartRoot() + 'cart';
          })
          .catch(function () {
            if (atc) atc.classList.remove('is-loading');
            window.location.href = cartRoot() + 'cart';
          });
      });
    }
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-sdh-root]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
